import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions'
import { i18n } from 'arm-common';

class UploadImage extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[UploadImage.jsx] ";
        this.caricaFile = this.caricaFile.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.confirmOnClick = this.confirmOnClick.bind(this);
        this.importFileUpload = this.importFileUpload.bind(this);
        this.state = {
            file: null,
            filePojo: null
        };
    }


    confirmOnClick() {
        console.log(this.componentName + 'confirmOnClick');
        if (this.state.file === null) {
            console.warn("file is NULL")
            return false;
        }


        let file = this.state.file;
        let formData = new FormData();
        formData.append('file', file);

        let idProdotto = this.props.idProdotto;
        if (idProdotto !== undefined && idProdotto !== null && idProdotto !== "") {
            formData.append('idProdotto', idProdotto);
        }

        this.props.uploadFile(formData).then(
            resolve => {
                // this.props.getListaDocumenti(idProdotto);
            }
        )
        this.props.close();
    }


    handleFile(event) {
        event.preventDefault();
        let e = event.dataTransfer === undefined ? event.target : event.dataTransfer || null;
        if (!e) {
            console.warn(this.componentName + "no event for drop file");
            return;
        }

        console.log(this.componentName + " handleFile " + e.files[0].name, e);
        let file = e.files[0];

        this.props.inputChangeHandler("nomeImg", e.files[0].name);

        this.setState({ file: file });
    }

    caricaFile(event) {
        let e = event.dataTransfer === undefined ? event.target : event.dataTransfer;
        console.log(this.componentName + " caricaFile " + e.files[0].name, e);

        let filePojo = new Object();
        let that = this;

        let reader = new FileReader();
        reader.readAsDataURL(e.files[0]);
        reader.onload = function (e) {

            console.warn("file data: " + e.target.result);
        }

        this.setState({ filePojo: filePojo });
    }

    importFileUpload(filePojo) {
        console.log(this.componentName + 'importFileUpload');
        let self = this;
        if (filePojo === undefined || filePojo !== null) {
            return Promise.resolve({ ok: false });
        }


        return this.props.uploadFile(filePojo).then(
            resolve => {

            }
        );


    }

    render() {
        console.log(this.componentName + 'render [show]' + this.props.show);
        return (

            <agui.ConfirmModalOkCancelV4 show={this.props.show} >
                <agui.ConfirmModalOkCancelV4.Header testoTitle="Upload" onClose={this.props.close} />
                
                
                    <div className="row mt-1 mb-3 ml-3">

                        <input name="file" type="file" onChange={(e) => this.handleFile(e)} />

                    </div>

                <agui.ConfirmModalOkCancelV4.Body  testoBody={(this.props.testoBody !== undefined && this.props.testoBody !== null) ?
                    this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI_VOLER', 'Confermi di voler procedere?')} />
               
                
                <agui.ConfirmModalOkCancelV4.Footer
                    testoButtonConfirm="Upload"
                    testoButtonCancel = {i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    //testoBody = {this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI_VOLER', 'Confermi di voler procedere?')}
                    confirmOnClick={this.confirmOnClick}
                    onClose={this.props.close}>
                </agui.ConfirmModalOkCancelV4.Footer>
            </agui.ConfirmModalOkCancelV4>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {
        uploadFile: function (formData) {
            return dispatch(ProdottoActions.uploadImage(formData));
        },

    }
};
export default connect(null, mapDispatchToProps)(UploadImage);
